import React from 'react';
import { Link } from 'react-router-dom';

import { Imagesdata } from '@/constants/Images';
import { getEnvVariables } from '@/constants/getEnvVariables';
import { useSessionStore } from '@/_zustand/sessionStore';
import useTranslation from '@/hooks/useTranslation';

const Error404 = ({route}) => {
  const { t } = useTranslation();
  const { handleLogout } = useSessionStore();
  const { INTRANET } = getEnvVariables();

  const logout = () => {
    localStorage.setItem('lastPatch',`/`);
    handleLogout();
  }
  
  if(route === 'main'){
    logout();
    return (
      <div>
        <div className="main-error-wrapper page-h">
          <img src={Imagesdata("Error404")} className="error-page" alt="error" />
          <h2>{t("Oopps. The page you were looking for doesn't exist.")}</h2>
          <h6>{t("You may have mistyped the address or the page may have moved.")}</h6>
          <Link className="btn btn-outline-danger" to={`/`}>{t('Back')}</Link>
        </div>
      </div>
    )
  }
  if(route === 'auth'){
    logout();
    return (
      <div>
        <div className="main-error-wrapper page-h">
          <img src={Imagesdata("Error404")} className="error-page" alt="error" />
          <h2>{t("Oopps. The page you were looking for doesn't exist.")}</h2>
          <h6>{t("You may have mistyped the address or the page may have moved.")}</h6>
          <Link className="btn btn-outline-danger" to={`/auth`}>{t('Back')}</Link>
        </div>
      </div>
    )
  }
  if(route === 'guest'){
    logout();
    return (
      <div>
        <div className="main-error-wrapper page-h">
          <img src={Imagesdata("Error404")} className="error-page" alt="error" />
          <h2>{t("Oopps. The page you were looking for doesn't exist.")}</h2>
          <h6>{t("You may have mistyped the address or the page may have moved.")}</h6>
          <Link className="btn btn-outline-danger" to={`/`}>{t('Back')}</Link>
        </div>
      </div>
    )
  }
  if(route === 'intranet'){
    logout();
    return (
      <div>
        <div className="main-error-wrapper page-h">
          <img src={Imagesdata("Error404")} className="error-page" alt="error" />
          <h2>{t("Oopps. The page you were looking for doesn't exist.")}</h2>
          <h6>{t("You may have mistyped the address or the page may have moved.")}</h6>
          <Link className="btn btn-outline-danger" to={`${INTRANET}/dashboard`}>{t('Back')}</Link>
        </div>
      </div>
    )
  }
};

export default Error404;
